import { render, staticRenderFns } from "./employeesDeductions.vue?vue&type=template&id=de7b9cfc"
import script from "./employeesDeductions.vue?vue&type=script&lang=js"
export * from "./employeesDeductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports